import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { ButtonMassActions } from "../common/Buttons";
import { IconLogout, IconUser, IconBack } from "./Icons";

export default function NavBar(props) {
  return (
    <nav className="navbar navbar-expand-lg navbar-light pb-0 p-left p-right">
      <span
        className="navbar-toggler-icon"
        id="menu-toggle"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          $("#wrapper").toggleClass("toggled");

          const collapseSetup =
            document.getElementById("wrapper").className === "d-flex toggled";

          localStorage.setItem("collapse", collapseSetup);
        }}
      ></span>
      <div className="pl-3">
        <h4 className="location-text d-flex align-items-center mb-0">
          {props.goBack && (
            <IconBack className="mr-2 cursor-pointer" onClick={props.goBack} />
          )}
          {props.location.locationName}
        </h4>
        <h5 className="location-subText">
          <Link style={{ paddingLeft: 0 }} to="/">
            Home
          </Link>

          {props.breadcrumbs ? (
            props.breadcrumbs.map((d) => (
              <React.Fragment key={`${d.label}_${d.value}`}>
                {">"}
                {d.onClick ? (
                  <a href="#" onClick={d.onClick}>
                    {d.label}
                  </a>
                ) : (
                  <Link to={d.value}>{d.label}</Link>
                )}
              </React.Fragment>
            ))
          ) : (
            <>
              {">"}
              <Link to={props.location.locationUrl}>
                {props.location.locationName}
              </Link>
            </>
          )}
        </h5>
      </div>
      <button
        className="navbar-toggler border-0"
        type="button"
        onClick={() =>
          document.querySelector(".user-menu").classList.toggle("show-nav")
        }
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse">
        <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
          <ButtonMassActions
            color="white"
            text={
              <div className="d-flex align-items-center justify-content-center">
                <IconUser />
                <span className="ml-2 font-weight-normal text-xs">
                  {props.user.firstname
                    ? `${props.user.firstname} ${
                        props.user.lastname
                          ? props.user.lastname.substr(0, 1) + "."
                          : ""
                      }`
                    : props.user.email}
                </span>
              </div>
            }
            actions={[
              {
                label: (
                  <span>
                    <IconLogout />
                    <span className="ml-2">Logout</span>
                  </span>
                ),
                onFunction: () => {
                  props.logout();
                },
              },
            ]}
          />
        </ul>
      </div>
    </nav>
  );
}
